import Vue from 'vue';

// routers 设定
import VueRouter from 'vue-router';
import fullscreenRouters from './fullscreen-router';
import menuRouters from './menu-router'; // 展示在菜单中的路由
import menuOtherRouters from './menu-other-router'; // 不展示在菜单中的详情页路由


import axios from 'axios';

// vuex store
import store from '../store/index';

// 路由配置
Vue.use(VueRouter);

// 路由包括菜单路由和其它路由
let allMenus = menuRouters.concat(fullscreenRouters, menuOtherRouters);

const RouterConfig = {
    mode: 'history', // 去除路由中的# 
    routes: allMenus
};
const router = new VueRouter(RouterConfig);
// 路由前置操作
router.beforeEach((to, from, next) => {
    const pathUrl = window.location.href;
    if (pathUrl.indexOf('/#/')>0 && to.fullPath.indexOf('h5')>0) {
        const targetUrl = pathUrl.replace('/#', '');
        window.location.href = targetUrl
    }
    const pathReWriteApi = '/app/scanningCode';
    if(pathUrl && pathUrl.indexOf('/ktz?')>=0){
        axios.post(pathReWriteApi, {
            params:  {
                qrCode:pathUrl
            },
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
            timeout: 60000
        })
            .then(res => {
                const jumpUrl = res.data.data.pageUrl;
                window.location.href = jumpUrl;
            })
            .catch(err => {
                console.log(err)
            })

    }else{
        // store.commit('updateBreadCrumb', to);
        if (to.meta.current) {
            store.commit('setCurMenuRouter', to.meta.current[0]);
            // store.commit('setCurMenuRouter',to.meta.parent);
            store.commit('setCurMenuOpened', to.meta.parent);
            next();
        } else {
            next();
        }
    }
});
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router;